import{css as o,modifier as e,variants as r}from"@lokalise/styled";import{color as t,typography as i,radius as n,spacing as d,fontFamily as a}from"../theme/index.js";const c=o`
	border-color: ${t("red.600")};
`,l=e("error",c),s=o`
	color: ${t("content.disabled")};
	background-color: ${t("surface.secondary")};
	border-color: ${t("border.primary")};
	cursor: not-allowed;

	&:hover,
	[data-dev-state='hover'] & {
		border-color: ${t("border.primary")};
	}

	&:focus,
	[data-dev-state='focus'] & {
		border-color: ${t("border.primary")};
	}

	&::placeholder {
		color: ${t("content.disabled")};
	}
`,p=o`
	${e("disabled",s)}

	&:disabled {
		${s}
	}
`,$=o`
	box-sizing: border-box;

	${i("description")};

	width: 100%;
	color: ${t("content.primary")};
	border: 1px solid ${t("border.primary")};
	border-radius: ${n("md")};
	transition: border-color ease-in-out 0.15s;
	padding: ${d(2,3)};
	background-color: ${t("background.input")};

	@media (prefers-reduced-motion: reduce) {
		transition: none;
	}

	&:hover,
	[data-dev-state='hover'] & {
		border-color: ${t("primary.300")};
	}

	&:focus-within,
	[data-dev-state='focus'] & {
		border-color: ${t("primary.500")};
	}

	${l}
	${p}
`,b=o`
	box-sizing: content-box;
	-webkit-font-smoothing: subpixel-antialiased;

	font-family: ${a("default")};
	${i("description")};
	color: ${t("content.primary")};
	background: none;

	&&&:focus,
	&&&:focus-visible,
	[data-dev-state='focus'] &&& {
		outline: none !important;
	}

	&::placeholder {
		${i("description")};
		color: ${t("content.secondary")};
	}

	${l}
	${p}
`,h=o`
	${$};
	${b};

	// Unfortunately, we need order of container -> input, but we need certain props from container
	// so we override those here. Currently I don't see way to combine those styles cleaner.
	box-sizing: border-box;
	background: ${t("background.input")};
`,u=o=>r("inputSize",o,"default"),m=35,f=30,g=u({small:o`
		height: ${28}px;
		min-height: ${28}px;
		line-height: ${28}px;
		${i("caption1")};

		&::placeholder {
			${i("caption1")}
		}

		&::-moz-placeholder {
			line-height: ${28}px;
		}
	`,default:o`
		height: ${33}px;
		min-height: ${33}px;
		line-height: ${33}px;

		&::-moz-placeholder {
			line-height: ${33}px;
		}
	`});export{u as buildInputSizeStyles,m as inputHeight,f as smallInputHeight,$ as withInputContainerStyle,p as withInputDisabledModifier,s as withInputDisabledStyle,l as withInputErrorModifier,c as withInputErrorStyle,b as withInputFieldStyle,g as withInputSizeVariants,h as withInputStyle};
//# sourceMappingURL=inputStyle.js.map
